import { Action } from '@ngrx/store';

import  { authActions ,isAuthenticated ,isUnAuthenticated } from './auth.actions';

export interface State{
    isUser:boolean
}
export const intialState:State ={

    isUser:false
};

export function authReducer(state = intialState,action: Action ){

    switch(action.type)
    {
        case isAuthenticated:
                return {
                    isUser:true
                }
        case isUnAuthenticated:
        return {
            isUser:false
        }
        default :{
            return state;
        }
    }
 
};

export const  getAuth =  (state:State) => state.isUser ;